export interface HomeRoute {
  kind: 'home'
}

export interface OrderRoute {
  kind: 'order'
  orderId: string
}

export type TrackerRoute = HomeRoute | OrderRoute

const getOrderIdFromSearch = (search: string) => {
  const searchParams = new URLSearchParams(search)
  const orderId = searchParams.get('orderId')

  return orderId ? decodeURIComponent(orderId) : ''
}

const stripBasePath = (pathname: string, basePath: string) => {
  if (basePath === '/') {
    return pathname
  }

  return pathname.startsWith(`${basePath}/`) || pathname === basePath
    ? pathname.slice(basePath.length) || '/'
    : pathname
}

export const parseTrackerRoute = (
  pathname: string,
  basePath: string,
  search = ''
): TrackerRoute => {
  const orderIdFromSearch = getOrderIdFromSearch(search)

  if (orderIdFromSearch) {
    return {
      kind: 'order',
      orderId: orderIdFromSearch,
    }
  }

  //XXX: may not be necessary anymore - backward compatibility with next/vercel
  const relativePath = stripBasePath(pathname, basePath)
  const pathWithoutTrailingSlash =
    relativePath.length > 1
      ? relativePath.replace(/\/+$/, '')
      : relativePath
  const segments = pathWithoutTrailingSlash.split('/').filter(Boolean)

  if (segments.length === 1) {
    return {
      kind: 'order',
      orderId: decodeURIComponent(segments[0]),
    }
  }

  return {
    kind: 'home',
  }
}
